export default __webpack_public_path__ + "static/media/MAFIA.f4ee44b4.svg";